export const ADD_AGENT_STARTED = 'ADD_AGENT_STARTED';
export const ADD_AGENT_COMPLETED = 'ADD_AGENT_COMPLETED';
export const ADD_AGENT_ERROR = 'ADD_AGENT_ERROR';

export const EDIT_AGENT_STARTED = 'EDIT_AGENT_STARTED';
export const EDIT_AGENT_COMPLETED = 'EDIT_AGENT_COMPLETED';
export const EDIT_AGENT_ERROR = 'EDIT_AGENT_ERROR';

export const FETCH_AGENTS_STARTED = 'FETCH_AGENTS_STARTED';
export const FETCH_AGENTS_COMPLETED = 'FETCH_AGENTS_COMPLETED';
export const FETCH_AGENTS_ERROR = 'FETCH_AGENTS_ERROR';

export const DELETE_AGENT_STARTED = 'DELETE_AGENT_STARTED';
export const DELETE_AGENT_COMPLETED = 'DELETE_AGENT_COMPLETED';
export const DELETE_AGENT_ERROR = 'DELETE_AGENT_ERROR';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/agentActionTypes.js